import { Route } from '@/app/router'

const SupplierOrder = () => import('./index.vue')

export default new Route('/supplier-order/:id', SupplierOrder)
	.as('Dashboard:SupplierOrder')
	.permissions(['VIEW_OEM_ORDER', 'OEM_ENABLED'])
